import React from 'react'

import {
    Button,
    Tooltip
} from "@mui/material";

import PersonPhotoIcon from "../../../assets/Images/photo1.png";
import ArrestIcon from "../../../assets/Images/ai1.png";
import InfoCopIcon from "../../../assets/Images/ic1.png";
import ETicketIcon from "../../../assets/Images/et1.png";
import ParkMobileIcon from "../../../assets/Images/pm1.png";
import ALPRIcon from "../../../assets/Images/alpr1.png";
import CADRMSIcon from "../../../assets/Images/Opencase1.png";
import CODISIcon from "../../../assets/Images/DNA1.png";
import TowingIcon from "../../../assets/Images/towing1.png";
import PrisonReleaseIcon from "../../../assets/Images/jail1.png";
import GunTraceIcon from "../../../assets/Images/WeaponTrace1.png";
import ShootingIcon from "../../../assets/Images/Shooting.png";
import ShootingSuspectIcon from "../../../assets/Images/ShootingRed.png";
import ShootingVictimIcon from "../../../assets/Images/ShootingGreen.png";
import NibinIcon from "../../../assets/Images/nibin1.png";
import NJGunTraceIcon from "../../../assets/Images/NjGunTrace1.png";
import PrisonParoleInactiveIcon from "../../../assets/Images/parole_Inactive.png";
import PrisonParoleActiveIcon from "../../../assets/Images/parole1.png";
import ViolentIcon from "../../../assets/Images/Violent1.png";
import HumanTrafficIcon from "../../../assets/Images/HumanTraffic1.png";
import ProfesionIcon from "../../../assets/Images/profession1.png";
import ReferralIcon from "../../../assets/Images/Referral1.png";
import ReferralRearrestedIcon from "../../../assets/Images/ReferralRearrested1.png";
import ArrestRecentIcon from "../../../assets/Images/aiRecent.png";
import PrisonReleaseRecentIcon from "../../../assets/Images/jailRecent.png";
import GunTraceRecentIcon from "../../../assets/Images/WeaponTraceTTC.png";
import NJGunTraceTriggerLockIcon from "../../../assets/Images/NjGunTraceTrigerLock.png";
import ProfileIcon from "../../../assets/Images/profile.png";
import DomViolenceIcon from "../../../assets/Images/domesticviolence.png";
import SexCrimeIcon from "../../../assets/Images/sexcrime.png";
import BTPersonReport from "../../shared/_BTPersonReport";
import { PersonInfo } from "../../../interfaces/getDarInfo_interface";

import {
    ColumnDirective,
    ColumnsDirective,
    ColumnMenu,
    GridComponent,
    Grid,
    Inject,
    Page,
    Sort,
    Filter,
    DetailRow,
    ExcelExport,
    PdfExport,
    Toolbar,
    Search, ExcelExportProperties,
    Resize, Reorder, Column
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-navigations';
import NJTracePerson from './_searchResultsNJTracePerson'
import NJTraceCaseDisplay from './_searchResultsNJTraceCase'
import { OpenCodisPDF } from "../../../services/detail.service";
import PersonIcon from "../../../assets/Images/Person.png";
import {showCrumbScore, SiteName} from '../../../services/config.service';
import BTPersonGridImage from "../../shared/_PersonGridImage";
import NJTrace from "../../../tools/njtrace/njtrace";
import { Avatar } from "@mui/material";
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import { green } from '@mui/material/colors';
import BTPersonIndicatorGrid from "../../shared/_PersonIndicators";
import {getValue} from "@syncfusion/ej2-base";
import {GetStringNameForSite} from "../../../interfaces/config.interface";
interface SearchResultsProps {
    NJTracePerson: PersonInfo[]
}

const SearchResultsPerson: React.FC<SearchResultsProps> = ({ NJTracePerson }) => {
    const [typedPerson, setTypedPersons] = React.useState<any>({})

    let grid: Grid | null;
    const miniPersonImage = (person: any): any => {
        return (
            <BTPersonGridImage person={person} />
        )
    }
    const IndicatorTemplate = (person: any): any => {
        return (
            <BTPersonIndicatorGrid person={person} />
        );
    }

    const getPersonSummary = (p: any) => {
        return (<div style={{maxWidth:"80%"}}><BTPersonReport person={p} /></div>)
    }

    const handleDataTyping = () => {
        if (NJTracePerson) {
            let tempP: any = [...NJTracePerson]

            for (let p of tempP) {
                if (p.DOB) {
                    p.DOB = new Date(p.DOB)
                }
                if (p.DTOFARREST) {
                    p.DTOFARREST = new Date(p.DTOFARREST)
                }
                if (p.DTOFUPDATE) {
                    p.DTOFUPDATE = new Date(p.DTOFUPDATE)
                }
            }
            setTypedPersons(tempP)
        }

    }

    React.useEffect(() => {
        handleDataTyping()
    }, [NJTracePerson])

    const GridToolsClick = (args: ClickEventArgs) => {
        if (grid && args.item.text === "Excel Export") {

            let excelProp: ExcelExportProperties = {}
            excelProp.fileName = 'NJTracePerson.xlsx';

            (grid.getColumnByField("image") as Column).visible = false;
            
            grid.excelExport();
            
        } else if (grid && args.item.text === 'PDF Export') {
            grid.pdfExport();
        }
    }

    const excelExportComplete = () => {
        if (grid) {
            (grid.getColumnByField("image") as Column).visible = true;
        }
    }
    
    const dataBound = () => {
        if (grid) {
            grid.autoFitColumns([])
        }
    }

    const expandRow = () => {
        if (grid) {
            const selectedrowindex: number[] = grid.getSelectedRowIndexes()
            for (let idx of selectedrowindex) {

                grid.detailRowModule.expand(idx)
            }
        }
    }

    return (
        <div className={"pl-10 pr-10 mt-5 border-2 border-gray-100 pb-5 pt-5"}>
            <span style={{display:"inline-block", width:"full"}}>
                NJTrace Person Information <img className={"inline ml-2"} src={PersonIcon} alt="ai" />
                {(NJTracePerson && NJTracePerson.length > 0) ? <h4 className={"font-bold pl-5"}> {NJTracePerson.length} Records Found</h4> : <h4 className={"font-bold pl-5"}>No Records Found</h4>}
            </span>
            {NJTracePerson && NJTracePerson.length > 0 ? <>
            <GridComponent
                dataSource={typedPerson}
                allowPaging={true}
                dataBound={dataBound}
                pageSettings={{ pageSize: 25, pageSizes: [10, 25, 50, 100] }}
                allowSorting={true}
                allowMultiSorting={true}
                allowFiltering={true}
                filterSettings={{ type: 'CheckBox' }}
                detailTemplate={getPersonSummary}
                allowTextWrap={true}
                textWrapSettings={{ wrapMode: 'Both' }}
                allowExcelExport={true}
                allowPdfExport={true}
                toolbar={['Search']}
                toolbarClick={GridToolsClick}
                excelExportComplete={excelExportComplete}
                ref={g => grid = g}
                selectionSettings={{
                    persistSelection: true,
                    type: "Multiple",
                    //checkboxOnly: true,
                    mode: "Row"
                }}
                //rowSelecting={(event: any) => { console.log(event) }}
                rowSelected={(event: any) => { expandRow() }}
                allowSelection={true}
                allowResizing={true}
                rowHeight={24}
                rowDataBound={(args : any) => {
                    if (args.row) {
                        if (getValue('FoundJail', args.data)  === 2){
                            args.row.classList.add('red');
                        }
                    }
                }}
            >

                <ColumnsDirective>
                    <ColumnDirective field='image' template={miniPersonImage} maxWidth={120} headerText='Image' customAttributes={{ class: ['e-attr'] }}/>
                    <ColumnDirective field='FName' headerText='First Name' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='MName' headerText='MI' width={110} minWidth={110} maxWidth={110} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='LName' headerText='Last Name' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='DOB' headerText='DOB' width={115} minWidth={115} maxWidth={115} format={{ type: 'date', format: 'MM/dd/yyyy' }} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='SERIAL_NUMBER' headerText='Weapon Serial #' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    { showCrumbScore ? <ColumnDirective field='CrumbScorePercentile' width={180} minWidth={180} maxWidth={180} headerText={`${GetStringNameForSite(SiteName,'SCOR_TBL')}Ranking`} customAttributes={{ class: ['e-attr'] }}/>:<></>}
                    <ColumnDirective field='FBI' headerText='FBI #' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='SBINo' headerText='SBI #' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='SBIState' headerText='SBI State' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='DLNo' headerText='DL #' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='DLSt' headerText='DL State' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective template={IndicatorTemplate} headerText='Indicator' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='STATUTE' headerText={`${GetStringNameForSite(SiteName,'STATUTE')}`} width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }}/>
                    <ColumnDirective field='STATUTEDESCRIPTION' headerText='Statute Description' maxWidth={250} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='DTOFARREST' format={{ type: 'date', format: 'MM/dd/yyyy' }} headerText='Date of Arrest' width={160} minWidth={160} maxWidth={160} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='ORIGINATINGORINAME' headerText='Agency Arrested' width={180} minWidth={180} maxWidth={180} customAttributes={{ class: ['e-attr'] }} />
                    <ColumnDirective field='Dept' headerText='InfoCop Dept' customAttributes={{ class: ['e-attr'] }} />
                </ColumnsDirective>
                <Inject services={[ColumnMenu, Sort, Page, Filter, DetailRow, Toolbar, ExcelExport, PdfExport, Search, Resize, Reorder]} />
                </GridComponent>
            </> : <></>}
        </div>

    )
};

export default SearchResultsPerson
